<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item>
                  <el-input
                    v-model="form.merchant_id"
                    placeholder="线索id"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.company"
                    placeholder="公司名称"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.mobile"
                    placeholder="手机号"
                  ></el-input>
                </el-form-item>

                <el-form-item>
                  <el-select
                    v-model="form.source"
                    placeholder="意向商家来源"
                    style="width: 150px"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in ops.source"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.follow_up_status"
                    placeholder="商家跟进状态"
                    style="width: 150px"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in ops.follow_up_status"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                  <el-select
                    v-model="form.is_settle_in"
                    placeholder="是否入驻"
                    style="width: 150px"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in ops.is_settle_in"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.no_reason_return"
                    placeholder="支持无理由退换货"
                    style="width: 150px"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in ops.no_reason_return"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="申请时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="datetimerange"
                    :default-time="['00:00:00', '23:59:59']"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="" @click="reset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <el-button
            slot="trigger"
            style="margin-left: auto"
            size="mini"
            type="success"
            @click="exportExcel"
            >导出</el-button
          >
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            :cell-class-name="addColor"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="center"
              prop="merchant_id"
              label="线索id"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="申请时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="source"
              label="意向商家来源"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="contract"
              label="姓名"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="mobile"
              label="联系方式"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="company"
              label="公司名称"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="company_address"
              label="公司地址"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="stall_address"
              label="档口地址"
            ></el-table-column>
            <el-table-column align="center" prop="" label="营业执照">
              <template slot-scope="scope">
                <img
                  v-viewer
                  :src="scope.row.license_pic"
                  alt=""
                  style="max-width: 80px; max-height: 80px"
                />
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="style"
              label="主打风格"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="main_category"
              label="主营类目"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="category"
              label="类目"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="own_factory_num"
              label="自有工厂数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="oem_factory_num"
              label="外包工厂数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="month_new_num"
              label="月上新量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="designer_num"
              label="设计师团队人数"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="annual_sales"
              label="年成交 GMV"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="dev_ability"
              label="开发能力"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="no_reason_return"
              label="无理由退换货"
            ></el-table-column>
            <el-table-column
              align="center"
              label="电商经营经验"
              prop="is_ecommerce_operate_experience"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="ecommerce_operate_platform"
              label="电商经营平台"
            ></el-table-column>
            <el-table-column align="center" prop="" label="工厂视频">
              <template slot-scope="scope">
                <video
                  :src="scope.row.factory_video"
                  style="max-width: 80px; max-height: 80px"
                  preload="metadata"
                  @click="open(scope.row.factory_video)"
                />
              </template>
            </el-table-column>
            <el-table-column align="center" prop="" label="办公室视频">
              <template slot-scope="scope">
                <video
                  :src="scope.row.office_video"
                  style="max-width: 80px; max-height: 80px"
                  preload="metadata"
                  @click="open(scope.row.office_video)"
                />
              </template>
            </el-table-column>
            <el-table-column align="center" prop="" label="商品1">
              <template slot-scope="scope">
                <img
                  v-viewer
                  :src="scope.row.product_pic1"
                  alt=""
                  style="max-width: 80px; max-height: 80px"
                />
                <p>{{ scope.row.product_price1 }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="" label="商品2">
              <template slot-scope="scope">
                <img
                  v-viewer
                  :src="scope.row.product_pic2"
                  alt=""
                  style="max-width: 80px; max-height: 80px"
                />
                <p>{{ scope.row.product_price2 }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="" label="商品3">
              <template slot-scope="scope">
                <img
                  v-viewer
                  :src="scope.row.product_pic3"
                  alt=""
                  style="max-width: 80px; max-height: 80px"
                />
                <p>{{ scope.row.product_price3 }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="" label="商品4">
              <template slot-scope="scope">
                <img
                  v-viewer
                  :src="scope.row.product_pic4"
                  alt=""
                  style="max-width: 80px; max-height: 80px"
                />
                <p>{{ scope.row.product_price4 }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="" label="商品5">
              <template slot-scope="scope">
                <img
                  v-viewer
                  :src="scope.row.product_pic5"
                  alt=""
                  style="max-width: 80px; max-height: 80px"
                />
                <p>{{ scope.row.product_price5 }}</p>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="follow_up_status"
              label="跟进状态"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="follow_up_admin_name"
              label="跟进人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="follow_up_msg"
              label="跟进信息"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="remark"
              label="原因备注"
            ></el-table-column>
            <el-table-column align="center" label="操作" fixed="right">
              <template slot-scope="scope">
                <div v-if="['1'].includes(scope.row.follow_up_status_int)">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="followUp(scope.row.merchant_id)"
                    >跟进</el-button
                  ><br />
                  <el-button
                    type="danger"
                    size="mini"
                    @click="
                      stopFollowUp('unFollowUp', 0, scope.row.merchant_id)
                    "
                    >不跟进
                  </el-button>
                </div>
                <div v-if="['2'].includes(scope.row.follow_up_status_int)">
                  <el-button
                    type="success"
                    size="mini"
                    @click="getFollowMsg(scope.row.merchant_id, 1)"
                    >记录跟进情况</el-button
                  >
                  <br />
                  <el-button
                    type="success"
                    size="mini"
                    @click="
                      stopFollowUp('finishFollowUp', 0, scope.row.merchant_id)
                    "
                    >完成跟进
                  </el-button>
                </div>
                <div v-if="['3'].includes(scope.row.follow_up_status_int)">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="getFollowMsg(scope.row.merchant_id, 0)"
                    >查看跟进信息</el-button
                  ><br />
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.count"
            :page-size="form.pagesize"
            :page-sizes="[10, 50, 100, 200, 500, 1000]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>

        <el-dialog
          :title="followUpTitle"
          :visible.sync="followUpVisible"
          width="40%"
        >
          <el-form :model="followUpForm">
            <el-form-item>
              <el-input
                v-model="followUpForm.remark"
                type="textarea"
                :rows="9"
                :placeholder="'请输入备注信息'"
                class="comment"
              ></el-input>
            </el-form-item>
            <el-form-item label="商家是否入驻: ">
              <el-radio v-model="followUpForm.is_settle_in" :label="1">
                是</el-radio
              >
              <el-radio v-model="followUpForm.is_settle_in" :label="2">
                否</el-radio
              >
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="followUpVisible = false">取 消</el-button>
            <el-button type="primary" @click="stopFollowUp('', 1)">
              确 定</el-button
            >
          </div>
        </el-dialog>

        <el-dialog
          :title="followUpMsgTitle"
          :visible.sync="followUpMsgVisible"
          width="40%"
        >
          <el-form v-if="followUpMsgInput" :model="followUpMsgForm">
            <el-form-item>
              <el-input
                v-model="followUpMsgForm.msg"
                type="textarea"
                :rows="9"
                :placeholder="'请输入最新跟进情况'"
                class="comment"
              ></el-input>
            </el-form-item>
          </el-form>

          <el-timeline>
            <el-timeline-item
              v-for="(msg, index) in followMsgs"
              :key="index"
              reverse="true"
              :timestamp="msg.time"
            >
              {{ msg.msg }}
            </el-timeline-item>
          </el-timeline>

          <div slot="footer" class="dialog-footer">
            <el-button @click="followUpMsgVisible = false">取 消</el-button>
            <el-button type="primary" @click="saveFollowMsg()">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchCondition();
    });
  },
  data() {
    return {
      resData: {},
      form: {
        create_time: this.defaultDate(),
        pagesize: 100,
      },
      loading: false,
      tableLoading: false,
      url: "/erp/Merchants/index",
      action: "",
      curPage: 1,
      filterFold: false,
      multipleSelection: [],
      followUpVisible: false,
      followUpMsgTitle: "",
      followUpMsgVisible: false,
      followUpTitle: "",
      followUpMsgForm: {},
      followUpForm: {},
      stopFollowAction: "",
      merchantId: 0,
      followUpMsgInput: false,
      followMsgs: [],
      ops: [],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    fetchCondition() {
      this.$http.post(this.url, { condition: 1 }).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.ops = res.data.data;
        }
      });
    },
    open(url) {
      window.open(url);
    },
    // 跟进
    followUp(id) {
      this.$confirm("确定跟进?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http
          .post("/erp/Merchants/followUp", { merchant_id: id })
          .then((res) => {
            this.loading = false;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$message.success(res.data.msg);
              this.fetchData(true);
            }
          });
      });
    },
    // 保存跟进信息
    saveFollowMsg() {
      this.followUpMsgForm.merchant_id = this.merchantId;
      this.$http
        .post("/erp/Merchants/saveFollowMsg", this.followUpMsgForm)
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.$message.success(res.data.msg);
            this.followUpMsgVisible = false;
            this.fetchData(true);
          }
        });
    },

    // 获取跟进信息
    getFollowMsg(id, input = 0) {
      this.merchantId = id;
      this.$http
        .post("/erp/Merchants/getFollowMsg", { merchant_id: id })
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.followMsgs = res.data.data.msgs;
            this.followUpMsgVisible = true;
            if (input == 1) {
              this.followUpMsgForm = {};
              this.followUpMsgInput = true;
            } else {
              this.followUpMsgInput = false;
            }
          }
        });
    },

    // 完成和不跟进
    stopFollowUp(action = "", post = 0, id = 0) {
      if (post == 1) {
        this.followUpForm.merchant_id = this.merchantId;
        this.$http
          .post(`/erp/Merchants/${this.stopFollowAction}`, this.followUpForm)
          .then((res) => {
            this.loading = false;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$message.success(res.data.msg);
              this.followUpVisible = false;
              this.fetchData(true);
            }
          });
      } else {
        this.stopFollowAction = action;
        this.followUpVisible = true;
        this.merchantId = id;
        if (action == "finishFollowUp") {
          this.followUpTitle = "完成跟进";
        } else {
          this.followUpTitle = "不跟进原因";
        }
      }
    },
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()} 23:59:59`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 15);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()} 00:00:00`;
      return [start, end];
    },
    addColor({ row, column, columnIndex }) {
      // if (columnIndex === 15) {
      //     return 'blue-cell';
      // }
    },
    exportExcel() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },

    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },

    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      for (const key in val) {
        multipleSelection[key] = val[key].work_id;
      }
      this.multipleSelection = multipleSelection;
    },

    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSizeChange(val) {
      this.form.pagesize = val;
      this.fetchData(true);
    },

    search() {
      this.form.page = 1;
      this.loading = true;
      this.fetchData(true);
    },

    trim(str, is_global) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    reset() {
      this.search_value = "";
      this.form = {};
      this.form.page = 1;
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/merchants/index.vue